module.exports = __webpack_public_path__ + "img/logo.d34d565d.jpeg";